import * as tslib_1 from "tslib";
import MailListItem from './MailListItem';
import onMailListItemClickHandler from '../utils/onMailListItemClickHandler';
import getBackgroundColorClass from '../selectors/getBackgroundColorClass';
import getIsChecked from '../selectors/getIsChecked';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import Draggable from 'owa-dnd/lib/components/Draggable';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { isGroupTableQuery } from 'owa-group-common';
import { tabIndex } from 'owa-mail-focus-manager';
import { showMailItemContextMenu } from 'owa-mail-list-actions/lib/actions/itemContextMenuActions';
import MailListContextMenuSource from 'owa-mail-list-store/lib/store/schema/MailListContextMenuSource';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { MailListItemExpansion } from 'owa-mail-list-view';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import { getAnchorForContextMenu } from 'owa-positioning';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { getMailListRowDragPreview, MAIL_ITEM_DRAG_XOFFSET, MAIL_ITEM_DRAG_YOFFSET, } from '../utils/mailListDragUtil';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { keydownHandler } from 'owa-hotkeys';
import { getCommands } from 'owa-mail-hotkeys';
import MailListContextMenuType from 'owa-mail-list-store/lib/store/schema/MailListContextMenuType';
import { AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import getUnreadItemClass from '../selectors/getUnreadItemClass';
var styles = require('./MailListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var MailListItemContainer = /** @class */ (function (_super) {
    tslib_1.__extends(MailListItemContainer, _super);
    function MailListItemContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lastIsFocused = false;
        _this.trySetFocus = function () {
            var isSelectionRefactorEnabled = isMailFeatureEnabled('tri-selectionRefactor');
            if ((!isSelectionRefactorEnabled &&
                _this.listViewItem &&
                _this.props.mailListItemDataProps.isSelected &&
                _this.isSingleItemSelected) ||
                (isSelectionRefactorEnabled && _this.listViewItem && _this.shouldRowBeFocused)) {
                // Focus on self if ref exists and the item is focused and focus is in mail list already
                // We need state checks here because this is being called async on requestAnimationFrame,
                // but we should not check if focus is in listview because the selected row may have been deleted at this point
                _this.listViewItem.focus();
                _this.listViewItem.setAttribute('tabindex', tabIndex.sequentialIndex);
                // Reset listview content tabindex such that listview is
                // not in a sequential keyboard navigation anymore once an item selected
                _this.props.resetListViewContentTabIndex();
            }
        };
        _this.resetTabIndex = function () {
            if ((isMailFeatureEnabled('tri-selectionRefactor') &&
                _this.listViewItem &&
                !_this.props.mailListItemDataProps.isSelected) ||
                (!isMailFeatureEnabled('tri-selectionRefactor') &&
                    _this.listViewItem &&
                    !_this.shouldRowBeFocused)) {
                // Clear tab index on item when it's no longer focused
                // We need state checks here because this is being called async on requestAnimationFrame
                _this.listViewItem.setAttribute('tabindex', tabIndex.nonSequentialIndex.toString());
            }
        };
        /**
         * The onContextMenu event handler which opens the context menu
         * @param evt the mouse event
         */
        _this.onItemContextMenu = function (evt) {
            evt.stopPropagation();
            evt.preventDefault();
            var tableView = listViewStore.tableViews.get(_this.props.mailListTableProps.tableViewId);
            var selectedRows = tableView.selectedRowKeys;
            // Select the row upon right click if
            // - user is not in selectAll mode
            // - and the row that clicked on is not selected yet
            if (!tableView.isInVirtualSelectAllMode &&
                (!selectedRows || !selectedRows.has(_this.props.mailListItemDataProps.rowKey))) {
                onMailListItemClickHandler(evt, MailListItemSelectionSource.MailListItemContextMenu, _this.props.mailListItemDataProps.rowKey, _this.props.mailListTableProps.tableViewId);
            }
            showMailItemContextMenu(getAnchorForContextMenu(evt), MailListContextMenuType.All, MailListContextMenuSource.MailListItem);
        };
        _this.updateFocusOnSelectionChange = function (isSelected, shouldBeFocused) {
            if (isMailFeatureEnabled('tri-selectionRefactor')) {
                if (_this.shouldRowBeFocused && _this.props.isFocusInMailList()) {
                    window.requestAnimationFrame(_this.trySetFocus);
                }
                else if (!_this.shouldRowBeFocused) {
                    // Only need to clear tab index if an item goes from selected to unselected
                    window.requestAnimationFrame(_this.resetTabIndex);
                }
            }
            else {
                if (_this.lastIsSelected != isSelected &&
                    _this.isSingleItemSelected &&
                    _this.props.isFocusInMailList()) {
                    if (isSelected) {
                        window.requestAnimationFrame(_this.trySetFocus);
                    }
                    else if (_this.lastIsSelected != undefined) {
                        // Only need to clear tab index if an item goes from selected to unselected
                        window.requestAnimationFrame(_this.resetTabIndex);
                    }
                }
            }
            _this.lastIsSelected = _this.shouldRowBeFocused;
            _this.lastIsFocused = _this.shouldRowBeFocused;
        };
        _this.setListViewItemRef = function (ref) {
            _this.listViewItem = ref;
        };
        _this.onClick = function (evt) {
            var _a = _this.props, mailListItemDataProps = _a.mailListItemDataProps, mailListTableProps = _a.mailListTableProps;
            onMailListItemClickHandler(evt, MailListItemSelectionSource.MailListItemBody, mailListItemDataProps.rowKey, mailListTableProps.tableViewId);
        };
        _this.onDoubleClick = function (evt) {
            var _a = _this.props, mailListItemDataProps = _a.mailListItemDataProps, mailListTableProps = _a.mailListTableProps;
            if (mailListTableProps.supportsDoubleClick) {
                onMailListItemClickHandler(evt, MailListItemSelectionSource.MailListItemBodyDoubleClick, mailListItemDataProps.rowKey, mailListTableProps.tableViewId);
            }
        };
        // In checked mode we have the parent container be draggable
        _this.canDrag = function () {
            var tableView = listViewStore.tableViews.get(_this.props.mailListTableProps.tableViewId);
            return (!tableView.selectedRowKeys.has(_this.props.mailListItemDataProps.rowKey) &&
                _this.props.mailListTableProps.canDragFromTable);
        };
        _this.getDragData = function () {
            var itemProps = _this.props.mailListItemDataProps;
            var tableView = listViewStore.tableViews.get(_this.props.mailListTableProps.tableViewId);
            return {
                itemType: DraggableItemTypes.MailListRow,
                rowKeys: [_this.props.mailListItemDataProps.rowKey],
                tableViewId: _this.props.mailListTableProps.tableViewId,
                tableListViewType: tableView.tableQuery.listViewType,
                subjects: [itemProps.subject ? itemProps.subject : strings.noSubject],
                latestItemIds: [itemProps.latestItemId],
            };
        };
        return _this;
    }
    Object.defineProperty(MailListItemContainer.prototype, "isChecked", {
        get: function () {
            var tableView = listViewStore.tableViews.get(this.props.mailListTableProps.tableViewId);
            return getIsChecked(tableView, this.props.mailListItemDataProps.rowKey, this.props.mailListItemDataProps.lastDeliveryTimestamp);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailListItemContainer.prototype, "isSingleItemSelected", {
        get: function () {
            var tableView = listViewStore.tableViews.get(this.props.mailListTableProps.tableViewId);
            if (!tableView) {
                return false;
            }
            return tableView.selectedRowKeys.size == 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailListItemContainer.prototype, "shouldRowBeFocused", {
        get: function () {
            var tableView = listViewStore.tableViews.get(this.props.mailListTableProps.tableViewId);
            if (!tableView) {
                return false;
            }
            return tableView.focusedRowKey === this.props.mailListItemDataProps.rowKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MailListItemContainer.prototype, "didFocusChange", {
        get: function () {
            return this.lastIsFocused !== this.shouldRowBeFocused;
        },
        enumerable: true,
        configurable: true
    });
    MailListItemContainer.prototype.getLabelForMailItem = function () {
        var _a = this.props.mailListItemDataProps, unreadCount = _a.unreadCount, importance = _a.importance, hasAttachment = _a.hasAttachment, isFlagged = _a.isFlagged, isPinned = _a.isPinned, subject = _a.subject;
        var labelArray = [];
        if (unreadCount > 0) {
            labelArray.push(strings.unreadFilter);
        }
        if (importance === 'High') {
            labelArray.push(strings.important);
        }
        if (hasAttachment) {
            labelArray.push(strings.hasAttachments);
        }
        if (isFlagged) {
            labelArray.push(strings.flaggedFilter);
        }
        if (isPinned) {
            labelArray.push(strings.pinnedGroupHeader);
        }
        labelArray.push(subject);
        return labelArray.join(' '); // convert into string
    };
    MailListItemContainer.prototype.render = function () {
        // Run focus related logic if selection changes
        var _a = this.props, mailListItemDataProps = _a.mailListItemDataProps, mailListTableProps = _a.mailListTableProps;
        var isSelected = mailListItemDataProps.isSelected;
        var isSelectionRefactorEnabled = isMailFeatureEnabled('tri-selectionRefactor');
        if (!isSelectionRefactorEnabled && isSelected) {
            this.updateFocusOnSelectionChange(isSelected);
        }
        else if (isSelectionRefactorEnabled && this.didFocusChange) {
            this.updateFocusOnSelectionChange(isSelected, this.shouldRowBeFocused);
        }
        var backgroundColorClass = getBackgroundColorClass(mailListItemDataProps, mailListTableProps, this.isChecked);
        var unreadItemClass = getUnreadItemClass(this.props.mailListItemDataProps, this.props.mailListTableProps, this.isChecked, styles.unreadMailListItem, styles.unreadMailListItemDarker);
        var shouldBackgroundChangeOnHover = !isSelected && !this.isChecked;
        // Outer container CSS classes that are shared between 3 column and single line views
        var mailListItemOuterContainerClasses = classNames(styles.mailListItem, backgroundColorClass, shouldBackgroundChangeOnHover && styles.backgroundChangeOnHover, styles.showHoverActionsOnHover, mailListItemDataProps.unreadCount > 0 && unreadItemClass);
        var itemAriaProps = {
            role: AriaRoles.option,
            selected: isSelected,
            label: this.getLabelForMailItem() || null,
        };
        return (React.createElement("div", tslib_1.__assign({ "data-convid": mailListItemDataProps.conversationId, ref: this.setListViewItemRef, tabIndex: -1, className: styles.mailListItemContainer }, generateDomPropertiesForAria(itemAriaProps)),
            React.createElement(Draggable, { canDrag: this.canDrag, getDragData: this.getDragData, getDragPreview: getMailListRowDragPreview, xOffset: MAIL_ITEM_DRAG_XOFFSET, yOffset: MAIL_ITEM_DRAG_YOFFSET },
                React.createElement("div", { className: mailListItemOuterContainerClasses, onClick: this.onClick, onDoubleClick: this.onDoubleClick, onContextMenu: this.onItemContextMenu, tabIndex: -1 },
                    React.createElement(MailListItem, { mailListTableProps: mailListTableProps, mailListItemDataProps: mailListItemDataProps }))),
            mailListItemDataProps.isExpanded && (React.createElement(MailListItemExpansion, { conversationId: mailListItemDataProps.rowId, tableViewId: mailListTableProps.tableViewId, isSingleLine: mailListTableProps.isSingleLine, tableViewSupportsFlagging: mailListTableProps.supportsFlagging }))));
    };
    MailListItemContainer.prototype.moveToFolder = function (evt) {
        this.moveToShortcutHandler(evt, MailListContextMenuType.MoveTo);
    };
    MailListItemContainer.prototype.moveToCategory = function (evt) {
        this.moveToShortcutHandler(evt, MailListContextMenuType.Categorize);
    };
    MailListItemContainer.prototype.moveToShortcutHandler = function (evt, ContextMenuType) {
        var tableView = listViewStore.tableViews.get(this.props.mailListTableProps.tableViewId);
        // moving messages shorcut is disabled for groups
        if (isGroupTableQuery(tableView.tableQuery)) {
            return;
        }
        var selectedRows = tableView.selectedRowKeys;
        if (selectedRows.size > 0) {
            var clientRect = evt.currentTarget.getBoundingClientRect();
            showMailItemContextMenu({ x: clientRect.right, y: clientRect.top }, ContextMenuType);
        }
    };
    tslib_1.__decorate([
        computed
    ], MailListItemContainer.prototype, "isChecked", null);
    tslib_1.__decorate([
        computed
    ], MailListItemContainer.prototype, "isSingleItemSelected", null);
    tslib_1.__decorate([
        computed
    ], MailListItemContainer.prototype, "shouldRowBeFocused", null);
    tslib_1.__decorate([
        computed
    ], MailListItemContainer.prototype, "didFocusChange", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().moveToFolder)
    ], MailListItemContainer.prototype, "moveToFolder", null);
    tslib_1.__decorate([
        keydownHandler(getCommands().categorize)
    ], MailListItemContainer.prototype, "moveToCategory", null);
    MailListItemContainer = tslib_1.__decorate([
        observer
    ], MailListItemContainer);
    return MailListItemContainer;
}(React.Component));
export default MailListItemContainer;
//# sourceMappingURL=MailListItemContainer.js.map